import React from "react";
import Phone from "../../assets/landingPage/phone.jsx";
import Email from "../../assets/landingPage/email.jsx";

const AgentSidebarMobile = (props) => {
  return (
    <div className="relative bottom-0 left-0 w-full bg-white shadow-md border-t border-gray-300 p-4 flex items-center justify-between sm:flex lg:hidden">
      {/* Agent Info */}
      <div className="flex items-center gap-3">
        <img
          src={props.imageURL ? props.imageURL : "/profile-avatar.jpg"}
          alt="Agent"
          className="w-10 h-10 rounded-full"
        />
        <div className="flex flex-col">
          <h3 className="text-sm font-semibold">{props.agentName}</h3>
          <p className="text-xs text-gray-500">Listing Agent</p>
        </div>
      </div>

      {/* Contact Buttons */}
      <div className="flex gap-3">
        <a
          href={props.phoneNumber ? `tel:${props.phoneNumber}` : "tel:(904)650-3761"}
          className="w-10 h-10 flex items-center justify-center border-2 border-[#0062ff] text-[#0062ff] rounded-full"
        >
          <Phone className="w-5 h-5" />
        </a>

        <a
          href={props.emailAddress ? `mailto:${props.emailAddress}` : "mailto:example@mail.com"}
          className="w-10 h-10 flex items-center justify-center bg-[#0062ff] text-white rounded-full"
        >
          <Email className="w-5 h-5" />
        </a>
      </div>
    </div>
  );
};

export default AgentSidebarMobile;
